import { render } from "./footer.vue?vue&type=template&id=5ac89ba6"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=5ac89ba6&lang=css"
script.render = render

export default script